module.exports = __webpack_public_path__ + "img/yinying.e898cd54.png";